import { FunctionComponent, useEffect, useState } from "react";
import { ConfiguratorOptions, NodeCustomizer } from "@rromikas/configurio";
import { Mesh } from "three";
import CustomizerComponent from "./customizer";
import { generateNodeCustomizer } from "utils/generate-node-customizer";
import CustomizerHeader from "../groups-list/customizer-header";

interface ModelPartCustomizerProps {
  mesh: Mesh;
  onSave: (val: ConfiguratorOptions["customizers"][number]) => void;
  initialValue?: ConfiguratorOptions["customizers"][number];
  index: number;
  onClose: () => void;
}

const ModelPartCustomizer: FunctionComponent<ModelPartCustomizerProps> = ({ mesh, index, onSave, onClose, initialValue }) => {
  const [value, setValue] = useState<NodeCustomizer | undefined>(undefined);
  useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
    } else {
      setValue(generateNodeCustomizer(index, mesh.name));
    }
  }, [initialValue]);

  return !value ? null : (
    <div className="px-6 pb-6 h-full overflow-auto">
      <CustomizerHeader
        name={value.name}
        setName={(val) => setValue((prev) => (!prev ? prev : { ...prev, name: val }))}
        onClose={onClose}
        onSave={() => onSave(value)}
      />
      <CustomizerComponent
        className="mb-12"
        value={value.color}
        setValue={(val) => setValue({ ...value, color: val })}
        type="color"
      />
      <CustomizerComponent value={value.material} setValue={(val) => setValue({ ...value, material: val })} type="material" />
    </div>
  );
};

export default ModelPartCustomizer;
